import { t } from "@/lib/i18n";

export function getMenus() {
  return [
    {
      name: t("home"),
      path: "/main",
      icon: "fa-th-large",
      tag: "",
    },
    {
      name: t("schedule"),
      path: "/main/schedule",
      icon: "fa-calendar-alt",
      tag: "list_schedule",
    },
    {
      name: "OS",
      icon: "fa-clipboard",
      path: "",
      tag: "list_os",
      children: [
        {
          name: "Rastreador",
          icon: "fa-clipboard",
          path: "/main/os",
          tag: "list_os",
        },
        {
          name: "Software",
          icon: "fa-laptop",
          path: "/main/os-sw",
          tag: "list_os_sw"
        },
        {
          name: "Finalizadas",
          icon: "fa-clipboard-check",
          path: "/main/os-finished",
          tag: "list_os_finished"
        }
      ],
    },
    {
      name: t("tests"),
      path: "/main/ostests",
      icon: "fa-clipboard-list",
      tag: "list_ostest",
    },
    {
      name: t("actives_movement_batch"),
      path: "/main/activesmovementbatch",
      icon: "fa-exchange-alt",
      tag: "activesmovementbatch",
    },
    {
      name: t("reports"),
      path: "/main/reports",
      icon: "mdi mdi-file-document-outline",
      tag: "reports",
    },
    {
      name: t("extract"),
      path: "/main/extract",
      icon: "fa-file-contract",
      tag: "list_extract",
    },
    {
      name: t("send_commands"),
      path: "/main/send-commands",
      icon: "fa-rocket",
      tag: "send_commands",
    },
    {
      name: t("settings"),
      path: "",
      icon: "fa-cog",
      tag: "list_settings",
      children: [
        {
          name: "Testar",
          icon: "fa-cogs",
          path: "/main/settings/testar",
          tag: "list_settings_testar",
        },
        {
          name: "Arena",
          icon: "fa-cogs",
          path: "/main/settings/arena",
          tag: "list_settings_arena",
        },
        {
          name: "Financeiro",
          icon: "fa-cogs",
          path: "/main/settings/financial",
          tag: "list_settings_financial"
        },
        {
          name: "Frota",
          icon: "fa-cogs",
          path: "/main/settings/frota",
          tag: "list_settings_frota"
        },
        {
          name: "Atendimentos",
          icon: "fa-cogs",
          path: "/main/settings/atendimentos",
          tag: "list_settings_atendimentos"
        },
        {
          name: "Integrador",
          icon: "fa-cogs",
          path: "/main/settings/integrador",
          tag: "list_settings_integrador"
        }
      ],
    },
    {
      name: t("Sync"),
      path: "",
      icon: "fa-sync",
      tag: "sync",
      children: [
        {
          name: "Serviços",
          icon: "fa-cogs",
          path: "/main/sync/service",
          tag: "list_sync_service",
        }
      ],
    },
    {
      name: t("frotix_management"),
      path: "/main/frotix-management",
      icon: "fa-chart-line",
      tag: "frotix_management",
    },
  ];
}
